import * as React from 'react';
import { WifiOff } from 'lucide-react';

/**
 * Faixa de "sem conexão".
 *
 * O aplicativo instalado abre offline — a casca está no cache —, mas nada
 * dentro dele funciona: toda tela depende da API, e nenhuma resposta é
 * guardada, porque seria dado de paciente parado no aparelho. Sem este aviso,
 * o usuário veria uma sequência de erros e concluiria que o sistema caiu.
 */
export function SemConexao() {
  const [offline, setOffline] = React.useState(() => !navigator.onLine);

  React.useEffect(() => {
    const conectou = () => setOffline(false);
    const desconectou = () => setOffline(true);

    window.addEventListener('online', conectou);
    window.addEventListener('offline', desconectou);

    return () => {
      window.removeEventListener('online', conectou);
      window.removeEventListener('offline', desconectou);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="status"
      className="bg-status-pendencia-fundo text-status-pendencia-texto border-status-pendencia-borda flex items-center justify-center gap-2 border-b px-4 py-2 text-sm"
    >
      <WifiOff className="size-4 shrink-0" aria-hidden="true" />
      <span>Sem conexão. O aplicativo abriu, mas não consegue falar com o servidor.</span>
    </div>
  );
}
